/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903853583 — Знижки */

import { getCurrencyBySubUnits } from '../../../../../shared';
import { useAppStore } from '../../../../../shared/hooks/useAppStore';
import { useDiscountedPrice } from '../../../hooks';
import { PriceDisplay } from '../PriceDisplay';

export function PriceWithPlanogram({
    className,
    amountInSubunits,
    originalAmountSubunits,
}: {
    className?: string;
    amountInSubunits: number;
    originalAmountSubunits: number;
}) {
    const vm = useAppStore((store) => store.vm);
    const priceView = useDiscountedPrice({
        amountInSubunits,
        inputAmount: getCurrencyBySubUnits(originalAmountSubunits),
        discountPercentage: vm?.campaign?.discount_percentage,
    });

    return (
        <PriceDisplay
            className={className}
            totalAmount={priceView.discountedAmount}
            originalAmount={priceView.originalAmount}
            savings={priceView.savings}
            currencyCode={vm?.currency_code}
            campaignMessage={vm?.campaign?.message}
            discountPercentage={vm?.campaign?.discount_percentage}
            startHour={vm?.campaign?.start_hour}
            endHour={vm?.campaign?.end_hour}
        />
    );
}
